import { useContext } from 'react';

import { MappingModalContext } from '@/context';

export const useMappingModalContext = () => {
  const context = useContext(MappingModalContext);
  if (context === null) {
    throw new Error('useMappingModalContext must be used within a MappingModalProvider');
  }
  return context;
};
